import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["caption", "children", "className", "fwdRef", "layout", "spacing", "zebra"];
import React, { Children, forwardRef, isValidElement } from 'react';
import { TableCaption } from '@op/opds.opux';
import { buildVersionedClassNames } from '@op/opds.opux-utilities';
/**
 * _Tables display sets of data structured into rows and columns to help users compare and analyse the data._
 *
 * ***
 *
 * The component is wrapper that mostly controls the styles of its children. Used together with the other table components.
 * See the example codes.
 *
 * Additional props (including `ref`) will be forwarded to the wrapping `<table>` element.
 */
export const Table = _ref => {
  let {
      caption = null,
      children,
      className,
      fwdRef,
      layout = 'default',
      spacing = 'default',
      zebra: zebraProp = null
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  function countRows() {
    let countedRows = 0;
    Children.forEach(children, child => {
      if (/*#__PURE__*/isValidElement(child)) {
        if (child && child.type === 'tbody') {
          countedRows += Children.count(child.props.children);
        } else {
          var _child$type;
          // @ts-expect-error -- The displayName is not part of our typings so TypeScript will show this as an error.
          const displayName = (_child$type = child.type) == null ? void 0 : _child$type.displayName;
          if (displayName === 'TableBody') {
            countedRows += Children.count(child.props.children);
          }
        }
      }
    });
    return countedRows;
  }
  const rows = countRows();
  const zebra = typeof zebraProp === 'boolean' ? zebraProp : rows > 3;
  const cl = buildVersionedClassNames('ds-table', className, {
    'ds-table--tile': layout === 'tile',
    ["ds-table--" + spacing]: spacing !== 'default',
    'ds-table--zebra': zebra
  });
  return /*#__PURE__*/React.createElement("table", _extends({}, props, {
    className: cl,
    ref: fwdRef
  }), caption && /*#__PURE__*/React.createElement(TableCaption, null, caption), children);
};
const Fwd = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/React.createElement(Table, _extends({}, props, {
  fwdRef: ref
})));
Fwd.displayName = 'Table';
export default Fwd;